module.exports = __webpack_public_path__ + "static/media/message_received.4b99825b.mp3";